/* eslint-disable react/prop-types */
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDefaultTheme, ThemeProvider } from '@concur/ui-theming';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PlaceholderComponent from '../PlaceholderComponent/_PlaceholderComponent';
import addStylesToDOM from './addStylesToDOM';
import isFiori from './isFiori';
import { GATEWAY_BRANDING_ID } from '../constants';

export default (WrappedComponent) => {
    const Component = (props) => {
        const {
            menuData,
            brandingId,
            themeName,
            useFullWidth,
            useSmallViewportBreakpoints,
            testStylesLoaded, // used so unit test snapshots don't just render the placeholder
        } = props;

        const {
            pageMenuItems = [],
        } = menuData || {};

        const getThemeToLoad = () => {
            if (brandingId === GATEWAY_BRANDING_ID) {
                return getDefaultTheme(brandingId);
            }

            return themeName || getDefaultTheme(brandingId);
        };

        const [stylesLoaded, setStylesLoaded] = useState(!!testStylesLoaded);

        Component.displayName = WrappedComponent.displayName || WrappedComponent.name || 'withStylesLoaded';

        useEffect(() => {
            // eslint-disable-next-line camelcase
            const cssUrl = `${__webpack_public_path__ || ''}main.sapCnqrThemedCss.__${getThemeToLoad()}__.css`;
            addStylesToDOM(cssUrl)
                .then(() => {
                    setStylesLoaded(true);
                })
                .catch(() => {
                    // TODO: what do we do here?
                });
        }, []);

        if (!stylesLoaded) {
            let componentType;

            if (!WrappedComponent.cssBlock
                && (menuData || props.onStartSession || props.actingAs)) {
                componentType = 'header';
            } else if (WrappedComponent.cssBlock === 'sapcnqr-app-footer') {
                componentType = 'footer';
            } else if (WrappedComponent.cssBlock === 'sapcnqr-app-mini-header') {
                componentType = 'mini-header';
            }

            if (componentType) {
                componentType = `${componentType}-${isFiori(brandingId, themeName) ? 'fiori' : 'gateway'}`;
            }

            return (
                <PlaceholderComponent
                    hasAdditionalContent={pageMenuItems && pageMenuItems.length > 0}
                    originalComponentType={componentType}
                    useFullWidth={useFullWidth}
                    useSmallViewportBreakpoints={useSmallViewportBreakpoints}
                />
            );
        }

        return (
            <ThemeProvider theme={getThemeToLoad()}>
                <WrappedComponent {...props} />
            </ThemeProvider>
        );
    };

    hoistNonReactStatics(Component, WrappedComponent);

    Component.propTypes = {
        brandingId: PropTypes.number,
        themeName: PropTypes.string,
    };

    Component.defaultProps = {
        brandingId: GATEWAY_BRANDING_ID,
    };

    return Component;
};
